import Title from 'antd/es/typography/Title';
import React, {FC} from 'react';

import {IPageTemplateProps} from 'pages';

import {usePDFLinkFallbackPage} from './hooks';
import {EPAGEMODES} from './pdf-link-fallback-page-constants';

export const PDFLinkFallbackPage: FC<IPageTemplateProps> = () => {
    const {
        mode, responseText, redirectTo, token, handleDownload,
    } = usePDFLinkFallbackPage();

    if (!redirectTo || !token) {
        return null;
    }

    return (
        <div>
            {mode === EPAGEMODES.HTTP_ERROR && (
                <Title level={4}>{responseText}</Title>
            )}
            {mode === EPAGEMODES.NOT_PDF && (
                <>
                    <Title level={2}>{responseText}</Title>
                    <div
                        onClick={handleDownload}
                    >
                        <a
                            href={redirectTo}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={e => {
                                e.preventDefault();
                            }}
                            style={{
                                fontSize: 20,
                                textDecoration: 'underline',
                            }}
                        >
                            Скачать
                        </a>
                    </div>
                </>
            )}

        </div>
    );
};
